import { default as AddToCart } from "./components/AddToCart";
import { default as CustomDimensionsForm } from "./components/CustomDimensionsForm";
import { default as Product } from "./components/Product";
import { default as SizeSelector } from "./components/SizeSelector";
import { default as UploadButton } from "./components/UploadButton";
import { default as OptionsUtility } from "./helpers/OptionsUtility";
import { default as DataStorage } from "./helpers/DataStorage";
import { default as ProductOptions } from "./containers/ProductOptions";
import { default as ProductQuantity } from "./containers/ProductQuantity";
import { default as Products } from "./containers/Products";
import { default as ProdSelector } from "./services/ProductSelector";
import { default as ThreekitReconciler } from "./services/ThreekitReconciler";
import { default as tkapi } from "./services/threekitApi";
import { default as fapi } from "./services/fabricApi";
import { default as LoadingSpinner } from "./components/LoadingSpinner";
import { default as GuaranteeIcons } from "./components/GuaranteeIcons";
import { default as PaymentIcons } from "./components/PaymentIcons";
import { default as ProductRating } from "./components/ProductRating";
import { default as ChangeImage } from "./components/ChangeImage";
import { default as CustomPrice } from "./components/CustomPrice";
import { default as TotalPrice } from "./components/TotalPrice";
import { default as ProductOption } from "./containers/ProductOption";
import { default as CheckboxOption } from "./components/CheckboxOption";
import { default as SelectOption } from "./components/SelectOption";
import { default as AddToCartUtility } from "./helpers/AddToCartUtility";
import { default as ModalAlert } from "./components/Modals/ModalAlert";
import { default as fixedImageData } from "./assets/fixedImageData";
import { default as CustomizeTools } from "./components/CustomizeTools/CustomizeTools";
import { default as TextTools } from "./components/CustomizeTools/TextTools";
import { default as MobileTextTools } from "./components/CustomizeTools/MobileTextTools";
import { default as Toolbar } from "./components/CustomizeTools/Toolbar";
import { default as FabricPlayer } from "./components/FabricJS/FabricPlayer";
import { default as FabricControls } from "./components/FabricJS/FabricControls";
import { default as FabricProductImage } from "./components/FabricJS/FabricProductImage";
import { default as VariantOptions } from "./components/VariantOptions";
import {
  mapSkuToAssetId,
  mapAssetIdToSku,
  assetIdToProductType,
  skuToProductType,
  mapHandleToAssetId,
} from "./services/skuMapper";

const stagingToken = "7b41fd4d-b76a-4383-bf4b-46147fd90e4b";
const prodToken = "b7254313-e2d7-4de8-9ab7-54cda7f6ad03";

const stagingOrgID = "00c181f6-4e03-411a-87fa-18a10b9f3ddb";
const prodOrdID = "7e9a4088-f8aa-4edb-b029-678d04fb77e8";

const stagingFileurl = "https://preview.threekit.com/api/files/";
const prodFileurl = "https://admin-fts.threekit.com/api/files/";

const stagingHost = "preview.threekit.com";
const prodHost = "admin-fts.threekit.com";

const prodUploadHost = "canvasprints.dev";
const stagingUploadHost = "staging.canvasprints.dev";

const uploadHost = () => {
  if (window.shopDomain == "canvasprintscom.myshopify.com") {
    return prodUploadHost;
  } else {
    return stagingUploadHost;
  }
};

const host = () => {
  if (window.shopDomain == "canvasprintscom.myshopify.com") {
    return prodHost;
  } else {
    return stagingHost;
  }
};

const fileUrl = () => {
  if (window.shopDomain == "canvasprintscom.myshopify.com") {
    return prodFileurl;
  } else {
    return stagingFileurl;
  }
};

const authToken = () => {
  if (window.shopDomain == "canvasprintscom.myshopify.com") {
    return prodToken;
  } else {
    return stagingToken;
  }
};

const orgID = () => {
  if (window.shopDomain == "canvasprintscom.myshopify.com") {
    return prodOrdID;
  } else {
    return stagingOrgID;
  }
};

const fabricApi = new fapi(authToken(), orgID(), host(), uploadHost());
const threekitApi = new tkapi(authToken(), orgID(), host(), uploadHost());
const ProductSelector = new ProdSelector(
  window.collectionName,
  window.productOptions
);

export {
  AddToCart,
  AddToCartUtility,
  authToken,
  CheckboxOption,
  CustomDimensionsForm,
  CustomPrice,
  DataStorage,
  GuaranteeIcons,
  PaymentIcons,
  LoadingSpinner,
  ModalAlert,
  OptionsUtility,
  Product,
  SelectOption,
  SizeSelector,
  UploadButton,
  ProductOptions,
  ProductQuantity,
  ProductOption,
  Products,
  ProductSelector,
  ThreekitReconciler,
  threekitApi,
  fabricApi,
  ProductRating,
  ChangeImage,
  orgID,
  fileUrl,
  TotalPrice,
  host,
  uploadHost,
  mapSkuToAssetId,
  mapAssetIdToSku,
  mapHandleToAssetId,
  assetIdToProductType,
  skuToProductType,
  CustomizeTools,
  TextTools,
  MobileTextTools,
  Toolbar,
  FabricPlayer,
  FabricControls,
  FabricProductImage,
  VariantOptions,
};
